import { Slider } from "..";
import * as S from "./styles";
import { useState } from "react";
import { FullScreenGallery } from "./fullscreen-gallery/FullScreenGallery";

const mountImages = (IMAGE: string, LINK?: string): any => ({
  IMAGE,
  LINK,
});

const ProductGallery = ({ image, id }: any) => {
  const [fullScreenImage, setFullScreenImage] = useState("");

  const handleImageClick = (image: any) => {
    setFullScreenImage(image);
  };

  const handleCloseFulScreen = () => {
    setFullScreenImage("");
  };

  return (
    <>
      {image && (
        <S.ProductGalleryWrapper>
          <Slider
            dots
            canSwipe
            isGallery
            autoplay={false}
            slidesToShow={1}
            id="main-gallery"
            slides={[mountImages(`${image}`)]}
            openFullScreen={handleImageClick}
            closeFullScreen={handleCloseFulScreen}
          />
        </S.ProductGalleryWrapper>
      )}

      {fullScreenImage && (
        <FullScreenGallery
          images={[
            mountImages(`${image}`),
          ]}
          firstImage={fullScreenImage}
          handleCloseFulScreen={handleCloseFulScreen}
        />
      )}
    </>
  );
};

export default ProductGallery;
